import React from 'react';
import { useDashboardPath } from 'Components/ClientApp/CombinedApp/Navigation/useDashboardPath';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';
import { NavButton } from '../NavButton';

export const HomeNavButton = () => {
  const { dashboardPath } = useDashboardPath();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (<NavButton
    value="home"
    label="Home"
    to={dashboardPath}
    onClick={() => {
      logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.navBarItem, {
        eventProperties: {
          navBarItem: 'Home',
        },
      });
    }}
  />);
};
